import React, { useEffect, useState } from 'react';
import './tooltip.css';
import { store } from '../../../app/store';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import './tooltip.css';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import Excel from '../../../components/Excel/Excel';
import { DownloadOutlined } from '@ant-design/icons';

export default function List({PopupID="", setIsEdit, setEditId}) {
    const store_data = JSON.parse(store());
    const [AdditionalCharge, setAdditionalCharge] = useState([]);
    
    // Permission states
    const [canView, setCanView] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [canToggleStatus, setCanToggleStatus] = useState(false);
    const [canExport, setCanExport] = useState(false);

    const fetchAdditionalCharge = async () => {
        const filter = { org_id: store_data?.org_id }
        const response = await postAPI("/additional-charges/list", filter);
        if (response?.status == 1) {
            setAdditionalCharge(response?.data);
        } else {
            setAdditionalCharge([]);
        }
        console.log(response)
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanCreate(true);
                setCanEdit(true);
                setCanDelete(true);
                setCanToggleStatus(true);
                setCanExport(true);
                fetchAdditionalCharge();
            } else {
                const viewAllowed = await hasPermission("SETTINGS", "AdditionalCharges", "VIEW");
                const createAllowed = await hasPermission("SETTINGS", "AdditionalCharges", "CREATE");
                const editAllowed = await hasPermission("SETTINGS", "AdditionalCharges", "EDIT");
                const deleteAllowed = await hasPermission("SETTINGS", "AdditionalCharges", "DELETE");
                const toggleAllowed = await hasPermission("SETTINGS", "AdditionalCharges", "TOGGLESTATUS");
                const exportAllowed = await hasPermission("SETTINGS", "AdditionalCharges", "EXPORT");
                
                setCanView(viewAllowed);
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
                setCanDelete(deleteAllowed);
                setCanToggleStatus(toggleAllowed);
                setCanExport(exportAllowed);
                
                if (viewAllowed) {
                    fetchAdditionalCharge();
                }
            }
        };
        checkPermissions();
    }, [])

    const handleChangeStatus = async (id, status) => {
        if (!canToggleStatus) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id, status: status }
        const response = await postAPI("/additional-charges/toggle-status", filter);
        if (response?.status == 1) {
            toast.success('Status changed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    const handleRemove = async id => {
        if (!canDelete) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id }
        const response = await postAPI("/additional-charges/remove", filter);
        if (response?.status == 1) {
            toast.success('Additional charges removed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    return (
        <>
            <ToastContainer />
            <table className="table card-table">
                <thead>
                    <tr>
                        <th>Additional Charge Name</th>
                        <th>Additional Charge Type</th>
                        <th>Additional Charge Value</th>
                        <th style={{width: '100px'}}>Status</th>
                        <th style={{width: '160px'}}>Actions</th>
                    </tr>
                </thead>
                <tbody className="table-border-bottom-0">
                    {
                        !canView ? (
                            <tr>
                                <td colSpan="5" className="text-center text-danger py-4">
                                    You do not have permission to view this page.
                                </td>
                            </tr>
                        ) : AdditionalCharge && AdditionalCharge.length > 0 ?
                            AdditionalCharge.map((val, index) => (
                                <tr key={index + 1}>
                                    <td>{val?.additional_charge_name}</td>
                                    <td>{val?.additional_charge_type}</td>
                                    <td>{val?.additional_charge_value}</td>
                                    <td>
                                        <span className="tooltip">
                                            <span className={`badge ${val?.status === 1 ? 'bg-label-success' : 'bg-label-secondary'} me-1 cursor-pointer`} onClick={() => handleChangeStatus(val?.id, !val?.status)}>
                                                {val?.status === 1 ? 'Active' : 'Inactive'}
                                            </span>
                                            <span className="tooltiptext">Change Status</span>
                                        </span>
                                    </td>
                                    <td>
                                        <span className="tooltip">
                                            <span className="badge bg-label-primary me-1" data-bs-toggle="modal" data-bs-target={`#${PopupID}`} onClick={() => {setIsEdit(true);setEditId(val?.id);}}><i className="fa fa-pen"></i></span>
                                            <span className="tooltiptext">Edit Additional Charge</span>
                                        </span>
                                        <span className="tooltip">
                                            <span className="badge bg-label-danger me-1 cursor-pointer"
                                                onClick={() => {
                                                    if (window.confirm("Are you sure? This action will permanently remove this data!")) {
                                                        handleRemove(val?.id);
                                                    } else {
                                                        console.log("Remove cancelled.");
                                                    }
                                                }}
                                            ><i className="fa fa-trash"></i></span>
                                            <span className="tooltiptext">Delete Additional Charge</span>
                                        </span>
                                    </td>
                                </tr>
                            ))
                            : ""
                    }
                </tbody>
            </table>
        </>
    )
}
